import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lucidChart = defineConnector({
  identifier: "lucidChart",
  name: "LucidChart",
  tagLine: "Diagramming and visual collaboration",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api.lucid.co/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a token in LucidChart",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developer.lucid.co/docs/api-keys](https://developer.lucid.co/docs/api-keys) to create a token for the LucidChart API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.lucid.co/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.lucid.co/documents")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
